var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShortLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3766_52526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66675 8.66599C6.95305 9.04874 7.31832 9.36545 7.73778 9.59462C8.15724 9.82379 8.62109 9.96007 9.09785 9.99421C9.57461 10.0284 10.0531 9.95957 10.501 9.79251C10.9488 9.62546 11.3555 9.36404 11.6934 9.02599L13.6934 7.02599C14.3006 6.39732 14.6366 5.55531 14.629 4.68132C14.6214 3.80733 14.2708 2.97129 13.6528 2.35326C13.0348 1.73524 12.1987 1.38467 11.3248 1.37708C10.4508 1.36948 9.60876 1.70547 8.98008 2.31266L7.83341 3.45266",
    stroke: "#007BFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33322 7.33283C9.04692 6.95008 8.68165 6.63338 8.26219 6.40421C7.84273 6.17503 7.37888 6.03875 6.90212 6.00461C6.42536 5.97047 5.94683 6.03925 5.49899 6.20631C5.05115 6.37337 4.64448 6.63479 4.30656 6.97283L2.30656 8.97283C1.69936 9.60151 1.36338 10.4435 1.37098 11.3175C1.37857 12.1915 1.72913 13.0275 2.34716 13.6456C2.96519 14.2636 3.80123 14.6142 4.67522 14.6217C5.54921 14.6293 6.39121 14.2934 7.01989 13.6862L8.15989 12.5462",
    stroke: "#007BFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3766_52526"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortLink);
export default __webpack_public_path__ + "static/media/short-link.7a797ede3f0ef89dea1431eb3b3be4ee.svg";
export { ForwardRef as ReactComponent };